import { useRouter } from 'next/router';

import { useDeviceBranding } from '@src/reducers/branding';

export const useSpecialPageBanners = () => {
  const { creditCalculator, calculatorSponsor } = useDeviceBranding() || {};
  const { query } = useRouter();

  const hasBanner = !!creditCalculator?.backgroundImage?.original;
  const isCRMSpecial = query.landing_type;

  return {
    withCRMBanner: hasBanner && isCRMSpecial,
    withMobileBanner: calculatorSponsor,
    isCRMSpecial,
  };
};
